//mascara de nomes so permite ser digitado letras
export function nome(e:React.FormEvent<HTMLInputElement>){
    e.currentTarget.maxLength = 45;
    let value = e.currentTarget.value;
    value = value.replace(/(\d)/g, "");
    return value;
}